namespace advisorop.components.meetinghub {
    export class MeetingDashboardController {
        meetingId: string;
        participantId: string;
        meetingLink: string;
        meeting: domains.IMeeting;
        currentParticipant: domains.IMeetingParticipant;

        _meetingHubService: services.MeetingHubService;

        constructor(private meetingHubService: services.MeetingHubService, private $sce: ng.ISCEService) {
            this._meetingHubService = meetingHubService
        }

        loadMeeting(): void {
            this.currentParticipant = undefined;
            this._meetingHubService.getMeeting(this.meetingId, this.participantId)
                .then(result => {
                    this.meeting = result.data;
                    this.getCurrentParticipant();
                });
        }

        getCurrentParticipant(): void {
            if (this.currentParticipant == undefined) {
                var participants = this.meeting.participants.filter(p => p.guid == this.participantId);
                if (participants.length > 0) {
                    this.currentParticipant = participants[0];
                }
            }
        }

        getMeetingLink(): string {
            let url = this.$sce.trustAsResourceUrl(this.meetingLink);
            return url;
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.meetingId = next.params.meetingId;
            this.participantId = next.params.participantId;
            //this.meetingLink = "http://localhost:3000/?sid=" + this.meetingId.trim() + "&pid=" + this.participantId.trim();
            this.meetingLink = "https://9b7e-104-186-148-108.ngrok.io/?sid=" + this.meetingId.trim() + "&pid=" + this.participantId.trim();
            this.loadMeeting();
        }

    }

    class MeetingDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = [`meetingHubService`, `$sce`, MeetingDashboardController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/views/meeting-dashboard.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingDashboard`, new MeetingDashboard());
}